import {
    BASE_URL
} from '../../config';

import {
    GET_USERS,
    DEACTIVATE_USER_DATA,
    ADD_USER_DATA,
    UPDATE_USER_DATA,
    ACTIVATE_USER_DATA,
    LOCK_USER_DATA,
    GET_NEW_DISTRIBUTOR_LIST,
    GET_NEW_DISTRIBUTOR_LIST_REQUEST,
    GET_NEW_DISTRIBUTOR_LIST_FAILURE,
    GET_PARTNERS_LIST,
} from "./admin.actionsTypes";

import axios from 'axios';

import delivery from '../../components/delivery/delivery';
import  { updateDistributor } from '../../components/distributors/distributors.actions';
import  { updateB2bUser } from '../B2bUsers/b2bUsers.actions';
import Notifier from '../../components/message/Notifier';
import { ERRORS, USER_ROLES } from "../../config/constants";

const sanitizeUserResponse = (user) => {
    if (!user || typeof user !== "object") return user;

    const next = { ...user };

    if (next.cert) {
        delete next.cert;
    }

    if (next.certificate) {
        delete next.certificate;
    }

    if (next.jks_file) {
        delete next.jks_file;
    }

    if (next.p12_file) {
        delete next.p12_file;
    }

    return next;
};


export const getUsers = (force = false) => {
    return (dispatch, getState) => {
        const state = getState ? getState() : {};
        const existingUsers = state?.users;

        if (Array.isArray(existingUsers) && existingUsers.length && !force) {
            return;
        }

        return axios.get(`${BASE_URL}user/`)
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: GET_USERS,
                        users: response.data
                    });
                }
            }).catch((e) => {
                console.error("User error: ", e);
            });
    };
};

export const getDeactivatedUsers = (cb = () => {}) => {
    return () => {
        axios.get(`${BASE_URL}user/deactivated`)
            .then((response) => {
                if (response.data) {
                    cb(response.data)
                }
            });
    };
};

export const getDeactiveTariffList = (params = {}, cb = () => {}) => {
    return () => {
        const query = new URLSearchParams(params).toString();
        axios.get(`${BASE_URL}tariff/tariffList?${query}`).then((response) => {
            if (response.data) {

                cb(response.data);
            }
        });
    };
};

export const updateSwitchDeletedTariffByAPI = (id,status) => {
    return (dispatch) => {
        axios.put(`${BASE_URL}tariff/status/${id}/${status}`).then((response) => {
            const isActive = status === 1
            if (response.data) {
                // dispatch(tariffDeleted(id));
                Notifier.success(
                    isActive?"_transaction_tariff_activation _":'_transaction_tariff_deactivation_'
                );
            }
        });
    };
};
export const deactivateUserData = (user) => {
    return {
        type: DEACTIVATE_USER_DATA,
        user
    };
};

export const deactivateUserByApi = (id, role, data, callback) => {
    return (dispatch) => {
        axios.put(`${BASE_URL}user/deactivate/${role}/${id}`, data)
            .then((response) => {
                if ('function' === typeof callback) {
                    callback(response);
                }
                if (response.data) {
                    dispatch(deactivateUserData({
                        isDeactive: response.data.isDeactive,
                        id,
                    }));
                    Notifier.success('_user_successfully_deactivated_', '_user_updated_');
                }
            })
            .catch(() => {
                callback();
            });
    };
};
export const activateUserData = (user) => {
    return {
        type: ACTIVATE_USER_DATA,
        user
    };
};
export const addUser = (user) => {
    return {
        type: ADD_USER_DATA,
        user
    };
};

export const addUserByApi = (user, callback) => {
    return (dispatch) => {
        axios.post(`${BASE_URL}user/`, user)
            .then((response) => {
                if ('function' === typeof callback) {
                    callback(response);
                }
                if (response.data) {
                    dispatch(addUser(sanitizeUserResponse(response.data)));
                }
            })
            .catch((error) => {
                console.error('ERRORS: ', error);
            });
    };
};

export const updateUserData = (user, id) => {
    return {
        type: UPDATE_USER_DATA,
        user,
        id
    };
};
export const updateUserByApi = (id, role, user, callback) => {
    return (dispatch) => {
        axios.put(`${BASE_URL}user/${role}/${id}`, user)
            .then((response) => {
                if ('function' === typeof callback) {
                    callback(response);
                }
                if (response.data) {
                    const sanitized = sanitizeUserResponse(response.data);
                    if (sanitized.role === USER_ROLES.DISTRIBUTOR) {
                        dispatch(updateDistributor({ ...sanitized, id }));
                    } else if (sanitized.role === USER_ROLES.B2B_USER) {
                        dispatch(updateB2bUser({ ...sanitized, id }));
                    }
                    dispatch(updateUserData(sanitized, id));
                    if (sanitized.role === USER_ROLES.SUPPLIER) {
                        dispatch(getPartnersList());
                    }
                }
            })
            .catch((e) => {
                Notifier.error('_something_went_wrong_');
            });
    };
};
export const activateUserByApi = (id, role, data, callback) => {
    return (dispatch) => {
        axios.put(`${BASE_URL}user/activate/${role}/${id}`, data)
            .then((response) => {
                if ('function' === typeof callback) {
                    callback(response);
                }
                if (response.data) {
                    dispatch(activateUserData({
                        isDeactive: response.data.isDeactive,
                        id,
                    }));
                }
            });
    };
};
export const checkUser = (user, callback) => {
    return (dispatch) => {
        axios.get(`${BASE_URL}user/check?username=${user}`)
            .then((response) => {
                if ('function' === typeof callback) {
                    callback(response.data);
                }
            });
    };
};
export const checkEmail = (user, callback) => {
    return (dispatch) => {
        axios.get(`${BASE_URL}user/check?email=${user}`)
            .then((response) => {
                if ('function' === typeof callback) {
                    callback(response.data);
                }
            });
    };
};

export const checkTerminalId = (terminalId, callback) => {
    return (dispatch) => {
        axios.get(`${BASE_URL}user/checkTerminalId?terminalId=${terminalId}`)
            .then((response) => {
                if ('function' === typeof callback) {
                    callback(response.data);
                }
            });
    };
}

export const updateDistributorStatus = (status, distributor) => {
    return (dispatch) => {
        const session = delivery.getSession();
        session.emit('delivery:distributorStatusUpdate', {
            status,
            distributor
        });
    };
};

export const generateApiToken = (_id, cb) => {
    return axios.post(`${BASE_URL}user/apiToken`, { _id }).then(cb);
};

export const createTemporaryPassword = (userId, password) => {
    return axios.put(`${BASE_URL}user/supplier/${userId}/temporary-password`, { password })
        .then((response) => {
            Notifier.success("Ժամանակավոր գաղտնաբառը ստեղծվել է։ Վավեր է 15 րոպե։");
            return response;
        });
};

export const getTemporaryPasswordTime = (userId) => {
    return axios.get(`${BASE_URL}user/supplier/${userId}/temporary-password`)
        .then((response) => response.data);
};
export const lockUserData = (user) => {
    return {
        type: LOCK_USER_DATA,
        user
    };
};

export const lockUserByApi = (id, data, callback) => {
    return (dispatch) => {
        axios.put(`${BASE_URL}user/lock/${id}`, data)
            .then((response) => {
                if ('function' === typeof callback) {
                    callback(response.data);
                }
                if (response.data) {
                    dispatch(lockUserData({
                        locked: response.data.locked,
                        id,
                    }));
                }
            });
    };
};

export const getTerminalId = (callback) => {
    return (dispatch) => {
        axios.get(`${BASE_URL}user/terminalId`)
            .then((response) => {
                if ('function' === typeof callback) {
                    callback(response.data);
                }
            });
    };
};

export const updateDistributorsInOptime = (callback) => {
    return () => {
        axios.post(`${BASE_URL}optime/distributor`)
            .then((response) => {
                if ('function' === typeof callback) {
                    callback(response.data);
                }
            });
    };
};

const normalizeFinanceParams = (params = {}) => {
    const p = { ...params };
    if (p._user_status_ != null && p.locked == null) p.locked = p._user_status_;
    delete p._user_status_;
    if (typeof p.locked === "string") p.locked = p.locked === "true";
    if (typeof p.isOnline === "string") p.isOnline = p.isOnline === "true";
    ["status", "sanitaryBookStatus"].forEach(key => {
        const val = p[key];
        if (Array.isArray(val)) {
            p[key] = val.map(v => {
                if (v === null || v === "null") return null;
                const n = Number(v);
                return Number.isNaN(n) ? v : n;
            });
            if (p[key].length === 0) delete p[key];
        } else if (val === "null") {
            p[key] = null;
        } else if (val != null && val !== "") {
            const n = Number(val);
            if (!Number.isNaN(n) && String(n) === String(val).trim()) {
                p[key] = n;
            }
        } else if (val === "" || val === undefined) {
            delete p[key];
        }
        // keep null for sanitaryBookStatus to be sent (do not delete)
    });
    return p;
};

const serializeParams = (params) => {
    const usp = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value === "" || value === undefined) return;
        if (value === null) {
            if (key === "sanitaryBookStatus") {
                usp.append(key, JSON.stringify(value));
            }
            return;
        }
        if (Array.isArray(value)) {
            // send as single param with array JSON value: status=[2,3] , sanitaryBookStatus=[null,3]
            // backend should parse JSON or comma-separated; we keep array literal for clarity
            // If backend expects repeated keys, it can also split by comma.
            // Using JSON.stringify keeps type (numbers/null) intact.
            const normalized = value.map(v => (v === "null" ? null : v));
            usp.append(key, JSON.stringify(normalized));
        } else {
            usp.append(key, String(value));
        }
    });
    return usp.toString();
};

export const getNewDistributorList = (params = {}) => {
    return (dispatch) => {
        const q = normalizeFinanceParams(params);
        dispatch({ type: GET_NEW_DISTRIBUTOR_LIST_REQUEST, loading: true });
        axios.get(`${BASE_URL}finance/balance/distributors`, { params: q, paramsSerializer: serializeParams })
            .then((response) => {
                const payload = response.data?.data?.distributors ? response.data.data : response.data;
                dispatch({
                    type: GET_NEW_DISTRIBUTOR_LIST,
                    allDistributors: payload,
                });
            })
            .catch((error) => {
                console.error("Error fetching new distributor list:", error);
                dispatch({ type: GET_NEW_DISTRIBUTOR_LIST_FAILURE, loading: false });
            });
    };
};

export const exportDistributorsCsv = (filters = {}) => {
    return axios.get(`${BASE_URL}finance/balance/distributors/export`, {
        params: normalizeFinanceParams(filters),
        paramsSerializer: serializeParams,
        responseType: "blob",
    });
};

export const getPartnersList = () => {
    return (dispatch) => {
        axios.get(`${BASE_URL}user/10`)
            .then((response) => {
                const allPartners = response.data;
                dispatch({
                    type: GET_PARTNERS_LIST,
                    allPartners,
                });
            })
            .catch((error) => {
                console.error("Error fetching partners list:", error);
            });
    };
};
